module.exports={
   "firebase": {
      "apiKey": "AIzaSyCkbPUAdcNn3ACH8XOeXlYCVvmyWyZ1Gn8",
      "authDomain": "form-engine-prod.firebaseapp.com",
      "databaseURL": "https://form-engine-prod.firebaseio.com",
      "projectId": "form-engine-prod",
      "storageBucket": "form-engine-prod.appspot.com",
      "messagingSenderId": "396100087895",
      "functionsBaseUrl": "https://api.formengine.com",
      "localPort": 5001
   }
}